import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/drag.png';
import _imports_1 from '@/assets/icons/add.png';
const _hoisted_1 = { class: "d-flex flex-column gap-8px" };
const _hoisted_2 = { class: "image-length-text" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "d-flex flex-wrap gap-8px"
};
const _hoisted_5 = { class: "d-flex flex-column align-items-center gap-8px" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "crop-internal" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    key: 0,
    class: "warning-badge position-absolute z-3 top-0 start-100 translate-middle badge rounded-pill bg-warning"
};
const _hoisted_10 = { class: "home-cropped-image-overlay" };
const _hoisted_11 = {
    key: 0,
    class: "z-3 fw-semibold text-secondary text-center"
};
const _hoisted_12 = { key: 1 };
const _hoisted_13 = {
    key: 0,
    for: "image-upload"
};
import { ref, toRef, watch, onMounted } from 'vue';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import draggable from "vuedraggable";
import ImgEditModal from './ImgEditModal.vue';
import PencilSVG from '../SVG/PencilSVG.vue';
import TriangleAlertSVG from '../SVG/TriangleAlertSVG.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImgUploadComponent',
    props: ['baseUrl', 'token', 'initImages'],
    emits: ['handleUpload'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const imagesData = ref([]);
        const currentImgData = ref(null);
        const baseUrl = toRef(props, 'baseUrl');
        const token = toRef(props, 'token');
        const initImages = toRef(props, 'initImages');
        const imgRef = ref(null);
        const isLoading = ref(false);
        const isEditModalOpen = ref(false);
        const DataURIToBlob = (dataURI) => {
            const splitDataURI = dataURI.split(',');
            const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
            const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
            const ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++)
                ia[i] = byteString.charCodeAt(i);
            return new Blob([ia], {
                type: mimeString
            });
        };
        const triggerFileUpload = () => {
            imgRef.value.click();
        };
        const updateImagesData = (val) => {
            if (val?.uuid) {
                const index = imagesData.value.findIndex((item) => item.uuid === val.uuid);
                if (index === -1) {
                    imagesData.value.push(val);
                }
                else {
                    imagesData.value[index] = val;
                }
            }
        };
        const handleImgUpload = async (file, size) => {
            return new Promise((resolve, reject) => {
                (async () => {
                    isLoading.value = true;
                    try {
                        const res = await axios.post(`${baseUrl.value}/v2/private/image-files`, { file, size }, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${token.value}`
                            }
                        });
                        currentImgData.value = res.data;
                        handleUpload();
                        resolve();
                    }
                    catch (err) {
                        console.log('error-->>', err);
                        reject(err);
                    }
                    finally {
                        isLoading.value = false;
                    }
                })();
            });
        };
        const handleImgselect = async (e) => {
            try {
                closeEditModal();
                if (e.target.files.length === 0)
                    return;
                const file = e.target.files[0];
                await handleImgUpload(file, "full");
                openEditModal();
            }
            catch (err) {
                console.log('error-->>', err);
            }
        };
        const handleEditImg = async (payload) => {
            const cardImg = DataURIToBlob(payload.card);
            const thumbImg = DataURIToBlob(payload.thumb);
            try {
                isLoading.value = true;
                const uploadImage = (file, size) => {
                    return axios.post(`${baseUrl.value}/v2/private/image-files`, { file, size, id: currentImgData.value.uuid }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${token.value}`
                        }
                    });
                };
                const cardImgRes = await uploadImage(cardImg, "card");
                currentImgData.value = cardImgRes.data;
                const thumbImgRes = await uploadImage(thumbImg, "thumb");
                currentImgData.value = thumbImgRes.data;
                updateImagesData(cardImgRes.data);
                updateImagesData(thumbImgRes.data);
                console.log(cardImgRes, 'thumbImgRes-->>', thumbImgRes);
                handleUpload();
            }
            catch (err) {
                console.log('error-->>', err);
            }
            finally {
                isLoading.value = false;
                closeEditModal();
            }
        };
        const handleRemoveImg = (uuid) => {
            const index = imagesData.value.findIndex((item) => item.uuid === uuid);
            if (index !== -1) {
                imagesData.value.splice(index, 1);
            }
            closeEditModal();
        };
        const openEditModal = () => {
            isEditModalOpen.value = true;
        };
        const closeEditModal = () => {
            isEditModalOpen.value = false;
        };
        const handleUpload = () => {
            emits('handleUpload', imagesData.value);
        };
        const onEditModal = (value) => {
            currentImgData.value = value;
            openEditModal();
        };
        watch(initImages, (val) => {
            imagesData.value = val;
        });
        onMounted(() => {
            if (initImages.value && Array.isArray(initImages.value)) {
                imagesData.value = initImages.value;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, " Immagini " + _toDisplayString(imagesData.value.length) + " / 5 ", 1),
                    (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_unref(VueElementLoading), {
                                active: isLoading.value,
                                spinner: "spinner",
                                color: "#2D489D"
                            }, null, 8, ["active"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_unref(draggable), {
                                tag: "ul",
                                list: imagesData.value,
                                class: "d-flex flex-wrap bg-white gap-16px p-0",
                                handle: ".handle",
                                "item-key": "uuid"
                            }, {
                                item: _withCtx(({ element }) => [
                                    _createElementVNode("li", _hoisted_5, [
                                        _createElementVNode("div", {
                                            class: "home-cropped-image position-relative",
                                            onClick: () => onEditModal(element)
                                        }, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("img", {
                                                    src: element?.card,
                                                    alt: element.alt
                                                }, null, 8, _hoisted_8)
                                            ]),
                                            (element?.cardFallback)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode(TriangleAlertSVG)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_10, [
                                                (element?.cardFallback)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "formato obsoleto, editare l'immagine per salvarla nel formato corretto"))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                        _createVNode(PencilSVG)
                                                    ]))
                                            ])
                                        ], 8, _hoisted_6),
                                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "drag-img d-flex" }, [
                                            _createElementVNode("div", { class: "handle" }, [
                                                _createElementVNode("img", { src: _imports_0 })
                                            ])
                                        ], -1))
                                    ])
                                ]),
                                _: 1
                            }, 8, ["list"]),
                            (imagesData.value.length < 5)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-add-image min-w-128px min-h-128px w-20 d-flex flex-column justify-content-center align-items-center" }, [
                                        _createElementVNode("img", { src: _imports_1 }),
                                        _createElementVNode("div", { class: "add-image-text" }, "Carica foto")
                                    ], -1)),
                                    _createElementVNode("input", {
                                        type: "file",
                                        accept: "image/*",
                                        id: "image-upload",
                                        ref_key: "imgRef",
                                        ref: imgRef,
                                        onChange: handleImgselect
                                    }, null, 544)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                ]),
                (isEditModalOpen.value)
                    ? (_openBlock(), _createBlock(ImgEditModal, {
                        key: 0,
                        isModalOpened: isEditModalOpen.value,
                        initialData: currentImgData.value,
                        onOnCloseModal: closeEditModal,
                        onOnRemoveImg: handleRemoveImg,
                        onHandleSubmit: handleEditImg,
                        onHandleNewUpload: triggerFileUpload
                    }, null, 8, ["isModalOpened", "initialData"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
